export enum ExternalReturnHubType {
  /** @deprecated ReturnBear is retired; kept for addresses that already store it. */
  RETURNBEAR = "returnbear",
  BLUEYONDER = "blueyonder",
  SHIPMONK = "shipmonk",
  SHIPHERO = "shiphero",
  RYDER = "ryder",
  DEPOSCO = "deposco",
  NETSUITE = "netsuite",
  MINTSOFT = "mintsoft",
}

export interface ExternalLocationHubConfig {
  provider: ExternalReturnHubType;
  locationId?: string;
}

export interface Address {
  _id?: any;
  externalLocationId?: string | null;
  name: string;
  street1: string;
  street2?: string;
  city: string;
  zip: string;
  state?: string;
  country: string;
  latitude?: number;
  longitude?: number;
  country_name?: string | null;
  phone?: string;
  email?: string | null;
  createdAt?: Date | null;
  updatedAt?: Date | null;
  trackstarWarehouseId?: string | null;
  inmarLocationId?: string | null;
  blueYonderLocationId?: string | null;
  isSekoHub?: boolean | null;
  aims360WarehouseId?: string | null;
  externalReturnHub?: {
    provider: ExternalReturnHubType;
    locationId?: string | null;
  } | null;
  returnsCenterId?: string | null;
}
